import app from '../stores/app';
import user from "../stores/user";
import {API_URL} from "./constants";

function ApiError(message, data) {
    const error = new Error(message);
    error.data = data;
    return error;
}

ApiError.prototype = Object.create(Error.prototype);

const getHeaders = () => {
    return {
        'Authorization': 'Bearer ' + user.token(),
        'View-By': app.getViewBy(),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
    };
};

const handleError = e => {
    console.log('handleError', e);
    return {
        error: e,
    }
};

const setJson = async response => {
    const details = await response.json();

    if (response && response.status) {
        if (response.status == 200) {
            return details;
        }
    }

    const msg = (details && details.message) || response.statusText;
    const data = (details && details.payload) || null;
    throw new ApiError(msg, data, response.status);
};

const POST = async (path, data = {}) => {
    let postData = {
        data
    }
    return await fetch(`${API_URL}/${path}`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(postData)
    }).then(setJson).catch(handleError);
};

const GET = async (url, o = null, loader = 0) => {
    const extra = o ? `?` + new URLSearchParams(o) : '';

    return await fetch(`${API_URL}/${url}${extra}`, {
        headers: getHeaders()
    }).then(setJson).catch(handleError);
};


export default {
    POST, GET
};
